import React, {useState} from "react";
import AppSettingController from "../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {base, DEFAULT_LANG, SUPPORTED_LANGS} from "../../../../routes/LangLayout";
import {SupportedLanguage} from "../../../../i18n";

export default function SelectLang() {
    const {t, i18n} = useTranslation();
    const navigate = useNavigate();
    const {lang} = useParams();
    const {pathname, search, hash} = useLocation();
    const initialLang: SupportedLanguage = (lang === "ar-IQ" || i18n.language === "ar-IQ") ? "ar-IQ" : DEFAULT_LANG;
    const [state, setState] = useState<SupportedLanguage>(initialLang);

    const values = [
        {value: "ar-IQ", label: "العربية (العراق)"},
        {value: "fa", label: "فارسی"},
    ];

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        AppSettingController.setMarketLang(state, e);
        const stripped = pathname.slice(base.length);
        const segments = stripped.split("/").filter(Boolean);
        if (segments.length > 0 && SUPPORTED_LANGS.includes(segments[0] as any)) {
            segments[0] = state;
        } else {
            segments.unshift(state);
        }
        navigate(`${base}/${segments.join("/")}${search}${hash}`, {replace: true});
    };

    return (
        <section>
            <p>{t("setting.selectLang")}</p>
            <div className={'form-receipt'}>
                <form onSubmit={handleSubmit}>
                    <select onChange={e => setState(e.target.value as SupportedLanguage)}
                            defaultValue={initialLang}>
                        {values.map(value => <option value={value.value} key={value.value}>{value.label}</option>)}
                    </select>
                    <button type="submit">{t("submit")}</button>
                </form>
            </div>
        </section>
    )
}
